import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { problems } from "@/mocks/public";

export default function ProblemsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-page">
        <SectionHeading
          eyebrow="Le quotidien sans outil"
          title="La gestion locative sur cahier ou Excel vous coûte du temps"
          description="Entre les notes dispersées, les retards oubliés et les documents éparpillés, suivre plusieurs immeubles devient vite très compliqué."
        />
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {problems.map((problem, index) => (
            <Reveal key={problem.title} delay={index * 80} className="h-full">
              <div className="card-lift group flex h-full flex-col gap-3 rounded-lg border border-background-200 bg-background-100/60 p-5 hover:border-primary-300 hover:bg-background-50">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${problem.icon} text-xl`} aria-hidden="true" />
                </span>
                <h3 className="text-base font-heading font-semibold text-foreground-950">{problem.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{problem.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}